module.exports = __webpack_public_path__ + "img/AboutPrincipalImageWeb.a8773894.jpg";